import React from "react";
import { graphql, useStaticQuery } from "gatsby";

interface ClientsProps {}
interface Logos {
  logo: {
    alternativeText: string;
    localFile: {
      publicURL: string;
    };
  };
  priorityOrder: number;
}
interface ClientLogos {
  allStrapiClientLogo: {
    nodes: Logos[];
  };
}
const Clients: React.FC<ClientsProps> = () => {
  const query: ClientLogos = useStaticQuery(graphql`
    query ClientLogos {
      allStrapiClientLogo(sort: { priorityOrder: ASC }) {
        nodes {
          logo {
            alternativeText
            localFile {
              publicURL
            }
          }
          priorityOrder
        }
      }
    }
  `);
  const result = query.allStrapiClientLogo.nodes;
  return (
    <div className="grid grid-cols-3 gap-4 md:gap-2 md:grid-cols-8">
      {result.map((data, i) => (
        <div key={i} className="md:mx-auto">
          <img
            src={data.logo.localFile.publicURL}
            alt={data.logo.alternativeText}
            className="w-[130px] h-[48px]"
          />
        </div>
      ))}
    </div>
  );
};

export default Clients;
